import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 cloud_opt_process iot_app_services"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={11} lg={10} className="m-auto text-center">
            <h3 className="h3_head">
              Why Choose TekRevol for IoT Application Development Services
            </h3>
            <p>
              TekRevol occupies the position of a reliable provider in the
              market of IoT development services with a solid list of
              high-profile projects created on its basis. This is why we have
              assembled our team of top IoT developers who create bespoke
              solutions addressing industries’ needs and fostering advancement.
            </p>
            <p>
              The advancements in internet technologies allow us to deliver IoT
              application development services that are scalable, secure, and
              high-performance. The fact that we value quality and stay on top
              of the industry trends makes us the perfect partner for your
              Internet of Things projects.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>Proven Track Record</h5>
                <p>
                  We have a history of delivering successful IoT projects across
                  diverse industries, showcasing our ability to meet complex and
                  unique client requirements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>Expert IoT Developers</h5>
                <p>
                  Our team comprises highly skilled developers with extensive
                  experience in designing, developing, and deploying advanced
                  IoT solutions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Cutting-Edge Technologies</h5>
                <p>
                  We utilize the latest technologies, including AI, machine
                  learning, edge computing, and cloud integration, to create
                  innovative and efficient IoT applications.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>Security Focused</h5>
                <p>
                  Our solutions prioritize security, implementing robust
                  protocols to protect data integrity, privacy, and compliance
                  with industry standards.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5>Customizable Services</h5>
                <p>
                  We offer highly customizable IoT solutions tailored to your
                  business needs, ensuring maximum relevance and impact.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5>Agile Development Methodology</h5>
                <p>
                  Our agile development process allows for flexibility and rapid
                  iteration, ensuring timely delivery and adaptability to
                  changing requirements.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
